import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import CustomButton from '../../../../../components/General/CustomButton';
import apiClient from '../../../../../requests/api/apiClient';
import { FetchError } from '../../../../types';
import { RouteParams } from '../../types';
import useStyles from '../styles';

export const DataRecoveryCard = () => {
  const classes = useStyles();

  const { id } = useParams<RouteParams>();
  const sectorId = id?.split('?')[0];

  const { enqueueSnackbar } = useSnackbar();

  // Estados para el módulo de recuperación de datos
  const [dataRecoveryStartDate, setDataRecoveryStartDate] = useState('');
  const [dataRecoveryEndDate, setDataRecoveryEndDate] = useState('');
  const [dataRecoveryLoading, setDataRecoveryLoading] = useState(false);

  const handleDataRecovery = async () => {
    if (!sectorId) {
      enqueueSnackbar('Error: No se encontró el ID del sector', { variant: 'error' });
      return;
    }

    setDataRecoveryLoading(true);
    try {
      const response = await apiClient.sector.publishSectorDataRecoveryBatches({
        sectorId,
        startDate: dataRecoveryStartDate,
        endDate: dataRecoveryEndDate,
      });

      enqueueSnackbar(
        `Recuperación de datos iniciada. Se publicaron ${response.data.batchesCount} lotes.`,
        { variant: 'success' },
      );
    } catch (error) {
      const { error: errorMessage } = error as FetchError;
      enqueueSnackbar(`Error al iniciar la recuperación de datos: ${errorMessage}`, {
        variant: 'error',
      });
    } finally {
      setDataRecoveryLoading(false);
    }
  };

  return (
    <Box mt={3} mb={3}>
      <Card>
        <CardContent>
          <Typography variant="h5" color="primary" gutterBottom>
            Recuperación de Datos
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="body1" color="textSecondary" sx={{ mb: 1 }}>
            Este módulo permite recuperar datos históricos en lotes de 30 días.
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Fecha de inicio"
                type="date"
                value={dataRecoveryStartDate}
                onChange={(e) => setDataRecoveryStartDate(e.target.value)}
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                label="Fecha de fin"
                type="date"
                value={dataRecoveryEndDate}
                onChange={(e) => setDataRecoveryEndDate(e.target.value)}
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Box display="flex" alignItems="flex-end" height="100%">
                <span>
                  <CustomButton
                    disabled={
                      dataRecoveryLoading
                      || !dataRecoveryStartDate
                      || !dataRecoveryEndDate}
                    buttonText={
                      dataRecoveryLoading
                        ? 'Procesando...'
                        : 'Iniciar Recuperación'
                    }
                    color='blue'
                    onClick={handleDataRecovery}
                  />
                </span>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};
export default DataRecoveryCard;
